import icImg from 'Assets/img/ic_file_img_20@2x.png';
import icPdf from 'Assets/img/ic_file_pdf_20@2x.png';
import icExcel from 'Assets/img/ic_file_excel_20@2x.png';
import icZip from 'Assets/img/ic_file_zip_20@2x.png';
import icPpt from 'Assets/img/ic_file_ppt_20@2x.png';
import icFile from 'Assets/img/ic_file_file_20@2x.png';
import icHwp from 'Assets/img/ic_file_hwp_20@2x.png';
import icGif from 'Assets/img/ic_file_gif_20@2x.png';
import icVideo from 'Assets/img/ic_file_video_20@2x.png';
import icDwg from 'Assets/img/ic_file_dwg_20@2x.png';
import icSkp from 'Assets/img/ic_file_skp_20@2x.png';

export const getExtensionImages2 = extension => {
  if (extension === 'pdf' || extension === 'PDF') return icPdf;
  if (extension === 'ppt' || extension === 'PPT' || extension === 'pptx' || extension === 'PPTX') return icPpt;
  if (extension === 'xlsx' || extension === 'XLSX' || extension === 'xls' || extension === 'XLS') return icExcel;
  if (extension === 'zip' || extension === 'ZIP' || extension === 'rar' || extension === 'RAR' || extension === '7z' || extension === '7Z') return icZip;
  if (extension === 'hwp' || extension === 'HWP') return icHwp;
  if (extension === 'gif' || extension === 'GIF') return icGif;
  if (extension === 'dwg' || extension === 'DWG') return icDwg;
  if (extension === 'skp' || extension === 'SKP') return icSkp;
  if (
    extension === 'png' ||
    extension === 'PNG' ||
    extension === 'jpg' ||
    extension === 'JPG' ||
    extension === 'jpeg' ||
    extension === 'JPEG' ||
    extension === 'bmp' ||
    extension === 'BMP' ||
    extension === 'svg' ||
    extension === 'SVG' ||
    extension === 'webp' ||
    extension === 'WEBP'
  ) {
    return icImg;
  }
  if (
    extension === 'mp4' ||
    extension === 'MP4' ||
    extension === 'avi' ||
    extension === 'AVI' ||
    extension === 'mov' ||
    extension === 'MOV' ||
    extension === 'wmv' ||
    extension === 'WMV' ||
    extension === 'flv' ||
    extension === 'FLV' ||
    extension === 'webm' ||
    extension === 'WEBM' ||
    extension === 'mkv' ||
    extension === 'MKV'
  ) {
    return icVideo;
  }

  return icFile;
};
